export const GROUP_NOT_FOUND_DATA_HOOK = 'GROUP_NOT_FOUND_DATA_HOOK';
